


















import Vue from "vue";
import Component from "vue-class-component";
import Topbar from "@/components/organisms/Topbar.vue";
import Sidebar from "@/components/organisms/Sidebar.vue";
import Footer from "@/components/organisms/Footer.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: { Sidebar, Topbar, Footer },
})
export default class Main extends Vue {
  name: "Main";

  @Prop({ default: "" })
  private lastName: string;

  @Prop({ default: "" })
  private firstName: string;

  private onClickScrollToTop(): void {
    window.scroll({ top: 0, behavior: "smooth" });
  }
}
